import React, { ReactNode, FunctionComponent } from "react";
import {
  Manager as PopoverManager,
  Reference as PopoverReference,
} from "react-popper";
import { BSMultiElement, Triggers } from "../../types";
import { useSharedState } from "../../hooks";
import { PopoverPopperProps, PopoverPopper } from "./PopoverPopper";

export interface PopoverProps extends Omit<PopoverPopperProps, "visible"> {
  content: ReactNode;
  children: (props: BSMultiElement) => JSX.Element;
  trigger?: Triggers | Triggers[];
  visible?: boolean;
  onToggle?: (visible: boolean) => void;
}

export const Popover: FunctionComponent<PopoverProps> = ({
  trigger = ["click"],
  children,
  content,
  onToggle,
  ...props
}) => {
  const [visible, set] = useSharedState(props.visible, onToggle);

  const triggers = {
    hover: {
      onMouseEnter: () => set(true),
      onMouseLeave: () => set(false),
    },
    focus: {
      onFocus: () => set(true),
      onBlur: () => set(false),
    },
    click: {
      onClick: () => set(!visible),
    },
  };

  return (
    <PopoverManager>
      <PopoverReference>
        {({ ref }) =>
          children({
            ref,
            ...(typeof trigger === "string" ? [trigger] : trigger)
              .map((t) => triggers[t])
              .reduce((obj: any, item: any) => {
                for (let i in item) obj[i] = item[i];
                return obj;
              }, {} as BSMultiElement),
          })
        }
      </PopoverReference>
      <PopoverPopper {...props} visible={visible}>
        {content}
      </PopoverPopper>
    </PopoverManager>
  );
};

export { PopoverManager, PopoverReference };
